export default __webpack_public_path__ + "images/cancerfondsrapporten/calendar-38.png";